import React, { useState } from "react";
import UpcomingPage from "./EventsPageComponents/Upcoming"; // import the UpcomingPage component
import CompletedPage from "./EventsPageComponents/Completed"; // import the CompletedPage component
import ApprovedPage from "./EventsPageComponents/ApprovedStatus";
import NotApprovedPage from "./EventsPageComponents/NotApproved";

const TabNavigation = () => {
  const [activeTab, setActiveTab] = useState("Upcoming");

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };

  // Render the corresponding page based on the active tab
  const renderTabContent = () => {
    switch (activeTab) {
      case "Upcoming":
        return <UpcomingPage />;
      case "Completed":
        return <CompletedPage />;
      case "Approved":
        return <ApprovedPage />;
      case "Not_Approved":
        return <NotApprovedPage />;
      default:
        return <UpcomingPage />;
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-16 space-y-6 mb-10">
      <div className="w-full max-w-7xl mx-auto mt-14 bg-white dark:bg-[#1a202c] rounded-xl shadow-2xl p-6">
        {/* Heading and description */}
        <div className="mb-6">
          <h1 className="text-3xl font-semibold text-gray-900 dark:text-white">
            Events
          </h1>
          <h6 className="text-sm font-bold text-[#b6b7ba] dark:text-[#b6b7ba] mt-2">
            See your scheduled events from your calendar.
          </h6>
        </div>

        {/* Navigation container with background and no underline */}
        <div className="flex flex-wrap justify-center sm:justify-start">
          <ul className="flex flex-wrap justify-center text-sm font-bold text-center text-[#a2a2a4] dark:text-[#a2a2a4] bg-[#f8f8f8] dark:bg-[#2d3748] rounded-lg mb-4">
            <li className="mr-2 mt-2 mb-2">
              <a
                onClick={() => handleTabClick("Upcoming")}
                className={`inline-block px-4 py-3 rounded-lg ml-2 ${
                  activeTab === "Upcoming"
                    ? "text-black bg-white"
                    : "text-[#a2a2a4] hover:text-gray-900 hover:bg-gray-200 dark:hover:bg-gray-800 dark:hover:text-white"
                }`}
                aria-current={activeTab === "Upcoming" ? "page" : undefined}
              >
                Upcoming
              </a>
            </li>
            <li className="mr-2 mt-2 mb-2">
              <a
                onClick={() => handleTabClick("Approved")}
                className={`inline-block px-4 py-3 rounded-lg ${
                  activeTab === "Approved"
                    ? "text-black bg-white"
                    : "text-[#a2a2a4] hover:text-gray-900 hover:bg-gray-200 dark:hover:bg-gray-800 dark:hover:text-white"
                }`}
              >
                Approved
              </a>
            </li>
            <li className="mr-2 mt-2 mb-2">
              <a
                onClick={() => handleTabClick("Not_Approved")}
                className={`inline-block px-4 py-3 rounded-lg ${
                  activeTab === "Not_Approved"
                    ? "text-black bg-white"
                    : "text-[#a2a2a4] hover:text-gray-900 hover:bg-gray-200 dark:hover:bg-gray-800 dark:hover:text-white"
                }`}
              >
                Hold
              </a>
            </li>
            <li className="mr-2 mt-2 mb-2">
              <a
                onClick={() => handleTabClick("Completed")}
                className={`inline-block px-4 py-3 rounded-lg ${
                  activeTab === "Completed"
                    ? "text-black bg-white"
                    : "text-[#a2a2a4] hover:text-gray-900 hover:bg-gray-200 dark:hover:bg-gray-800 dark:hover:text-white"
                }`}
              >
                Completed
              </a>
            </li>
          </ul>
        </div>

        {/* Render the corresponding page content */}
        <div className="mt-4 p-4">{renderTabContent()}</div>
      </div>
    </div>
  );
};

export default TabNavigation;
